// This file defines the layers for the South America region by merging the non-authenticated and common authenticated TOCs with specific layers for South America.

// Importing non-authenticated and common authenticated TOCs
import { non_authenticated, common_authenticated } from '@/constants/layers/index'

// Risk layers for South America
import { burningIndexSA } from '@/constants/layers/region/southAmerica/riskLayers/burningIndex'
import { energyReleaseSA } from '@/constants/layers/region/southAmerica/riskLayers/energyReleaseIndex'
import { fireDangerSA } from '@/constants/layers/region/southAmerica/riskLayers/fireDangerIndex'
import { mergeTocs } from '@/utils/layers'

// Reference layers for South America
import elevationSouthAmerica from './reference/elevationSouthAmerica'
import populationAndBuildingsSouthAmerica from './reference/populationAndBuildingsSouthAmerica'
import relativeNdviSouthAmerica from './reference/relativeNdviSouthAmerica'
import slopeSouthAmerica from './reference/slopeSouthAmerica'
import vegetationSouthAmerica from './reference/vegetationSouthAmerica'

// Merging the TOCs and defining the layers for South America
export const southAmericaLayers = mergeTocs(non_authenticated.toc, common_authenticated.toc, [
  { name: 'riskLayers', layers: [burningIndexSA, energyReleaseSA, fireDangerSA] },
  {
    name: 'reference',
    layers: [relativeNdviSouthAmerica, elevationSouthAmerica, slopeSouthAmerica, populationAndBuildingsSouthAmerica, vegetationSouthAmerica]
  }
  // Add other toc groups if needed
])
